import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

const featuredCategories = categories.slice(0, 6);

const descriptions: Record<string, string> = {
  shoes: "Os tênis mais procurados das planilhas CSSBuy. Nike, Jordan, Adidas e mais com preços exclusivos direto dos fornecedores chineses.",
  hoodies: "Moletons e suéteres de alta qualidade com designs exclusivos. Perfeitos para o estilo streetwear a preços imbatíveis.",
  tshirts: "Camisetas de algodão premium com estampas originais.Compare qualidade e preço antes de comprar.",
  jackets: "Jaquetas e casacos para todas as estações. De bombers a parkas, encontre o melhor custo-benefício.",
  pants: "Calças, shorts e bermudas dos melhores fornecedores. Todos os estilos com comparação detalhada de preços.",
  headwear: "Bonés, chapéus e gorros exclusivos. Acessórios que completam seu visual com estilo.",
};

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium uppercase tracking-wider mb-4">
            Categorias
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            {t("sectionCategories")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t("sectionCategoriesDesc")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          <a
            href={featuredCategories[0].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer md:col-span-2 md:row-span-2"
          >
            <div className="aspect-[4/3]">
              <img
                src={featuredCategories[0].imageUrl}
                alt={`${featuredCategories[0].namePt} - CSSBuy Spreadsheet`}
                title={`${featuredCategories[0].namePt} - planilha de preços CSSBuy`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/15 to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-5 md:p-6">
              <span className="inline-block px-2.5 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium mb-2">
                Destaque
              </span>
              <h3 className="text-lg md:text-xl font-heading font-bold text-background-50 mb-1.5">{featuredCategories[0].namePt}</h3>
              <p className="text-background-50/75 text-xs md:text-sm max-w-md leading-relaxed">
                {descriptions[featuredCategories[0].id] || ""}
              </p>
            </div>
          </a>

          {featuredCategories.slice(1).map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-2xl overflow-hidden cursor-pointer"
            >
              <div className="aspect-[3/2]">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.namePt} - CSSBuy Spreadsheet`}
                  title={`${cat.namePt} - guia de compras CSSBuy`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-3 md:p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-background-50 mb-1">{cat.namePt}</h3>
                <p className="text-background-50/70 text-xs leading-relaxed line-clamp-2">
                  {descriptions[cat.id] || ""}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}